(function(){
  'use strict';

  angular
    .module('app')
		.constant('disqusConfig', 'brastelha')

})();
